import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GARNET_TOKENS } from '../tokens.js';
/**
 * AssuranceKey — the three-swatch legend for the assurance spine (garnet.css `.akey`):
 * verified·machine (jade), verified·attestation (gold), flag (brick). Each swatch is a
 * left-bordered card with a mono label and a plain-language description.
 */
export function AssuranceKey() {
    return (_jsxs("div", { className: "akey", children: [_jsxs("div", { className: "sw m", children: [_jsx("div", { className: "lab", children: "Verified \u00B7 Machine" }), _jsx("div", { className: "desc", children: "A register or API answered. Deterministic, no human." })] }), _jsxs("div", { className: "sw a", children: [_jsx("div", { className: "lab", children: "Verified \u00B7 Attestation" }), _jsx("div", { className: "desc", children: "A credentialed professional confirmed it. Captured as evidence." })] }), _jsxs("div", { className: "sw f", children: [_jsx("div", { className: "lab", children: "Flag" }), _jsx("div", { className: "desc", children: "A mismatch, a stale source, or a signal that needs escalation." })] })] }));
}
/** AssuranceKeyMini — compact inline legend (garnet.css `.akey-mini`). */
export function AssuranceKeyMini() {
    const items = [
        ['machine', GARNET_TOKENS.verified],
        ['attestation', GARNET_TOKENS.attest],
        ['flag', GARNET_TOKENS.flag],
        ['unverified', GARNET_TOKENS.neutral],
    ];
    return (_jsx("div", { className: "akey-mini", children: items.map(([label, color]) => (_jsxs("span", { children: [_jsx("i", { style: { background: color } }), label] }, label))) }));
}
//# sourceMappingURL=AssuranceKey.js.map